import { Box, Center, Heading } from "@chakra-ui/react";
import React from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import DeskCheckIn from "../../components/booking/DeskCheckIn";
import BottomSheetWrapper from "../../components/BottomSheetWrapper";

const CheckIn = () => {
  const { deskId } = useParams<{ deskId: string }>();

  return (
    <BottomSheetWrapper>
      <BackButton />
      <Box p={5}>
        <Heading size="md" mb={5}>
          Check In
        </Heading>
        <DeskCheckIn deskId={deskId} />
      </Box>
    </BottomSheetWrapper>
  );
};

export default CheckIn;
